<template>
  <div>
    <v-row class="mx-6" v-resize="setNotificationCols">
      <v-col :cols="notificationCols">
        <v-menu
          ref="startMenu"
          v-model="startAtMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="startAtText"
              label="表示開始日"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startAt"
            no-title
          />
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col :cols="notificationCols">
        <v-menu
          ref="endMenu"
          v-model="endAtMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="endAtText"
              label="表示終了日"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endAt"
            no-title
            scrollable
          />
        </v-menu>
      </v-col>
    </v-row>
    <v-row class="mx-6">
        <v-col :cols="notificationCols">
        <v-text-field
          class="title__filed"
          v-model="title"
          label="件名"
          clearable
          :counter="10"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col :cols="notificationCols">
        <v-file-input
          label="添付ファイル"
          truncate-length="15"
          v-model="attachment"
        ></v-file-input>
      </v-col>
    </v-row>
    <v-row class="mx-6">
      <v-col :cols="notificationCols+4">
        <vue-editor v-model="message" />
      </v-col>
    </v-row>
    <v-btn
      class="mt-6 ml-6"
      small
      color="secondary"
      dark
      @click.stop="submit"
    >
      保存
    </v-btn>
  </div>
</template>

<script>
import moment from 'moment'
import { VueEditor } from "vue2-editor";
import { getNotificationCols } from '../../plugins/responsive'

export default {
  components: {
    VueEditor,
  },

  data () {
    return {
      startAtMenu: false,
      endAtMenu: false,
      notificationCols: getNotificationCols()
    }
  },

  computed: {
    startAt: {
      get () {
        return this.$store.state.notification.startAt
          ? moment(new Date(this.$store.state.notification.startAt)).format('YYYY-MM-DD')
          : ''
      },
      set (value) {
        this.$store.commit('notification/setStartAt', {
          startAt: value ? moment(new Date(value)).format('YYYY/MM/DD') : ''
        })
      }
    },
    endAt: {
      get () {
        return this.$store.state.notification.endAt
          ? moment(new Date(this.$store.state.notification.endAt)).format('YYYY-MM-DD')
          : ''
      },
      set (value) {
        this.$store.commit('notification/setEndAt', {
          endAt: value ? moment(new Date(value)).format('YYYY/MM/DD') : ''
        })
      }
    },
    title: {
      get () {
        return this.$store.state.notification.title
      },
      set (value) {
        this.$store.commit('notification/setTitle', {
          title: value
        })
      }
    },
    message: {
      get () {
        return this.$store.state.notification.message
      },
      set (value) {
        this.$store.commit('notification/setMessage', {
          message: value
        })
      }
    },
    attachment: {
      get () {
        return this.$store.state.notification.attachment
      },
      set (value) {
        this.$store.commit('notification/setAttachment', {
          attachment: value
        })
      }
    },
    startAtText: {
      get() {
        return this.startAt
          ? moment(new Date(this.startAt)).format('YYYY/MM/DD')
          : ''
      },
      set() {
        this.startAt = null
      }
    },
    endAtText: {
      get() {
        return this.endAt
          ? moment(new Date(this.endAt)).format('YYYY/MM/DD')
          : ''
      },
      set() {
        this.endAt = null
      }
    },
  },
  methods: {
    async submit() {
      const res = await this.$store.dispatch('notification/validate')
      if (res.status === 'error') this.$toasted.global.error({ message: res.message })
      else this.$emit('submit')
    },
    setNotificationCols() {
      this.notificationCols = getNotificationCols()
    }
  },
}
</script>

<style lang="stylus" scoped>

</style>
